import type { BroadcastStatus } from '@entities/broadcast';

const META: Record<BroadcastStatus, { label: string; cls: string }> = {
  draft: { label: 'Черновик', cls: '' },
  queued: { label: 'В очереди', cls: 'is-blue' },
  sending: { label: 'Отправляется', cls: 'is-blue' },
  done: { label: 'Завершена', cls: 'is-ok' },
  failed: { label: 'Ошибка', cls: 'is-err' },
  cancelled: { label: 'Отменена', cls: '' },
};

export function BcStatus({ status }: { status: BroadcastStatus }) {
  const m = META[status] ?? META.draft;
  return <span className={`bc-pill ${m.cls}`}>{m.label}</span>;
}

const MSK = 'Europe/Moscow';

/** «сегодня, 10:05» / «21 окт, 12:00». Бэкенд может отдать время без пояса (UTC). */
export function whenFull(iso: string) {
  const d = new Date(/[zZ]|[+-]\d\d:?\d\d$/.test(iso) ? iso : `${iso}Z`);
  const day = (x: Date) => x.toLocaleDateString('ru-RU', { timeZone: MSK });
  const t = d.toLocaleTimeString('ru-RU', { timeZone: MSK, hour: '2-digit', minute: '2-digit' });
  if (day(d) === day(new Date())) return `сегодня, ${t}`;
  return `${d.toLocaleDateString('ru-RU', { timeZone: MSK, day: 'numeric', month: 'short' }).replace('.', '')}, ${t}`;
}
